<div class="select-container">
  <div class="select-container__body">
    <select [(ngModel)]="firstSelection" (change)="onChangeCatalogueFormation()" [ngClass]="{'q-main-select--no-selection' : !firstSelection}" class="q-main-select">
  <!--    <ng-container *ngIf="catalogueAndFormation">-->
      <option class="q-main-select__no-selection" [ngValue]="undefined">--Sélectionner un catalogue ou offre--</option>
        <optgroup *ngFor="let element of catalogueAndFormation" label="{{element.type}}">
          <option *ngFor="let option of element.listSelect" [ngValue]="option">{{option.value}}</option>
        </optgroup>
    <!--  </ng-container>-->
    </select>

    <select [(ngModel)]="secondSelection" (change)="onChangeCategorieAction()" [disabled]="!firstSelection" [ngClass]="{'q-main-select--no-selection' : !secondSelection}" class="q-main-select">
      <option class="q-main-select__no-selection" [ngValue]="undefined">--{{secondSelectionTitle}}--</option>
      <option *ngFor="let option of catergorieOrAction" [ngValue]="option">{{option.value}}</option>
    </select>

    <select [(ngModel)]="thirdSelection" (change)="onChangeProduitSession()" [disabled]="!secondSelection" [ngClass]="{'q-main-select--no-selection' : !thirdSelection}" class="q-main-select">
      <option class="q-main-select__no-selection" [ngValue]="undefined">--{{thirdSelectionTitle}}--</option>
      <option *ngFor="let option of produitOrSession" [ngValue]="option">{{option.value}}</option>
    </select>
  </div>
</div>
